import { render, staticRenderFns } from "./Printings.vue?vue&type=template&id=06fc95e4&scoped=true&"
import script from "./Printings.vue?vue&type=script&lang=js&"
export * from "./Printings.vue?vue&type=script&lang=js&"
import style0 from "./Printings.vue?vue&type=style&index=0&id=06fc95e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fc95e4",
  null
  
)

export default component.exports